import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { generateRandomColor, getIndicatorsLabels } from '../../utils/helpers';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';


import { 
  Brush,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

export default function CustomLineChart({ data }) {
  const [labels, setLabels] = useState([]);
  const [toolTipId, setToolTipId] = useState('');

  useEffect(() => {
    // Extraim les etiquetes de l'indicador
    const uniqueLabels = getIndicatorsLabels(data);
    // Construim l'array amb els objectes que caracterizen cada linia
    const lineProperties = uniqueLabels.map((label) => {
        const color = generateRandomColor();
        return {id: label, hide: false, color}        
    });
    setLabels(lineProperties);
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  // Mostra la capsa de Tooltip customizada i només mostra els valors de la línia sobre la que s'ha fet el darrer onMouseEnter
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && toolTipId) {
      const line  = payload.find((item) => item.dataKey === toolTipId);
      return (
        <div style={{backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, paddingTop: 5, paddingBottom: 5, paddingLeft: 10, paddingRight: 10}}>
          <p style={{fontWeight: 'bold'}}>{`${label}`}</p>
          <p style={{color: line.color }}>{`${toolTipId}: ${line.value ||''}`}</p>          
        </div>
      );
    }  
    return null;
  };

  // Mostra o oculta una linea
  const toggleVar = (variable) => {
    const labelsUpdated = labels.map((label)=> {
      if (label.id === variable.dataKey) {
        return {
          ...label,
          hide: !label.hide
        }
      };
      return label
    })
    setLabels(labelsUpdated);
  };

  return (
    <div style={{ width: '100%', height: 600}}>        
      <ResponsiveContainer>
        <LineChart data={data} margin={{right: 60}}>      
          {
            labels.map((label) => <Line type='monotone' dataKey={label.id} stroke={label.color} hide={label.hide} key={label.id} onMouseEnter={() => setToolTipId(label.id)} onMouseLeave={() => setToolTipId('')} />)
          }
          <CartesianGrid stroke='#ccc' />
          <XAxis dataKey='date' />
          <YAxis />              
          <Tooltip content={<CustomTooltip />}/>
          <Brush dataKey='date' height={30} stroke='#8884d8'/>
          <Legend onClick={toggleVar} verticalAlign='bottom' wrapperStyle={{ position: 'relative', top: -20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, width: '100%'}} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

// Indica i controla els props que se han de passar al component
CustomLineChart.propTypes = {
  data: PropTypes.array.isRequired
};
